import { type ProductContext, type Device } from '../model';

import { type ExternalResponse, type Response } from './get-products-ads';

interface AdapterProps {
  context: ProductContext;
  device: Device;
  externalResponse: ExternalResponse;
}

export default function adapter(props: Readonly<AdapterProps>) {
  const { context, device, externalResponse } = props;

  const response: Response = {
    data:
      externalResponse[
        `${device}_${context.name}_${context.position}_product`
      ] || [],
  };

  return response;
}
